import React from "react";
import { Popover as AntPopover } from "antd";
import "./Popover.css";

export const Popover = (props) => <AntPopover overlayClassName="tailormed-popover" {...props} />;
